import { render, staticRenderFns } from "./SelectUserScopeDialog.vue?vue&type=template&id=7b23fc4c&scoped=true&"
import script from "./SelectUserScopeDialog.vue?vue&type=script&lang=js&"
export * from "./SelectUserScopeDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectUserScopeDialog.vue?vue&type=style&index=0&id=7b23fc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b23fc4c",
  null
  
)

export default component.exports